<template>
  <div class="layout-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')" title="尺寸" name="1">
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '1')"
          >
            <div class="verticallyCenter">
              <div class="verticallyCenter mr12 flex1">
                <span class="fs14 mr8 color000">宽</span>
                <single-input
                  v-if="direction === 'ltr' || direction === 'rtl' || direction === 'center'"
                  style="width: 100%"
                  value="-"
                  :value.sync="width"
                  inputSuffixs="px"
                />
                <!--                <el-input-->
                <!--                  type="number"-->
                <!--                  value="-"-->
                <!--                  v-if="direction === 'ltr' || direction === 'rtl'"-->
                <!--                  style="width: 100%"-->
                <!--                  v-inputHandle="{ this1, type: 'width' }"-->
                <!--                  v-model="width"-->
                <!--                >-->
                <!--                  <template slot="suffix">-->
                <!--                    <span class="suffix_text">px</span>-->
                <!--                  </template>-->
                <!--                </el-input>-->
                <el-input v-else type="number" value="100" disabled style="width: 100%">
                  <template slot="suffix">
                    <span class="suffix_text">%</span>
                  </template>
                </el-input>
              </div>
              <div class="verticallyCenter flex1">
                <span class="fs14 mr8 color000">高</span>
                <single-input
                  value="-"
                  v-if="direction === 'ttb' || direction === 'btt' || direction === 'center'"
                  style="width: 100%"
                  :value.sync="height"
                  inputSuffixs="px"
                />
                <!--                <el-input-->
                <!--                  type="number"-->
                <!--                  value="-"-->
                <!--                  v-if="direction === 'ttb' || direction === 'btt'"-->
                <!--                  style="width: 100%"-->
                <!--                  v-inputHandle="{ this1, type: 'height' }"-->
                <!--                  v-model="height"-->
                <!--                >-->
                <!--                  <template slot="suffix">-->
                <!--                    <span class="suffix_text">px</span>-->
                <!--                  </template>-->
                <!--                </el-input>-->
                <el-input v-else type="number" value="100" disabled style="width: 100%">
                  <template slot="suffix">
                    <span class="suffix_text">%</span>
                  </template>
                </el-input>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')" title="外观" name="2">
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')"
          >
            <div class="content-item mb16">
              <border-radius
                :borderTypeFlag.sync="borderTypeFlag"
                :borderRadius.sync="borderRadius"
                :borderTopLeftRadius.sync="borderTopLeftRadius"
                :borderTopRightRadius.sync="borderTopRightRadius"
                :borderBottomRightRadius.sync="borderBottomRightRadius"
                :borderBottomLeftRadius.sync="borderBottomLeftRadius"
              />
            </div>
            <div class="content-item mb24 clearFloat">
              <div class="checkbox_colorPicker_container mb16">
                <span class="fs14">边框</span>
              </div>
              <div class="select-input-container verticallyTop">
                <cx-border
                  :borderWidth.sync="borderWidth"
                  :borderStyle.sync="borderStyle"
                  :borderColor.sync="borderColor"
                  :borderIsThemeColor.sync="borderIsThemeColor"
                />
              </div>
            </div>
            <div class="content-item">
              <cx-background :background.sync="background" imgType="10" class="mt16" />
            </div>
            <div class="content-item mt16">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="boxShadowH"
                :boxShadowV.sync="boxShadowV"
                :boxShadowBlur.sync="boxShadowBlur"
                :boxShadowSpread.sync="boxShadowSpread"
                :boxShadowColor.sync="boxShadowColor"
              ></box-shadow>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
          title="背景遮罩"
          name="3"
        >
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')"
          >
            <div class="content-item mb16">
              <div class="checkbox_colorPicker_container">
                <span>遮罩颜色</span>
              </div>
              <cx-color-picker
                class="flex1"
                :isThemeColor.sync="modalTextIsThemeColor"
                :colorArr.sync="modalColorArr"
                :activeName.sync="modalActiveNameColor"
                :showSecondTab="true"
              >
              </cx-color-picker>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import positionSet from "./position-set.vue"
import autoLayoutSetting from "toolbarComponents/colsComponent/setting/autoLayoutSetting.vue"
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper"
import elementPluginSetting from "publicSetting/elementPluginSetting.vue"
import CxPadding from "../../../modules/components/cxPadding"
import { withMethodsHistoryCombine } from "utils/revork"

export default withMethodsHistoryCombine({
  name: "drawer-options-setting",
  props: {
    options: Object
  },
  data() {
    return {
      this1: this,
      activeNames: ["1", "2", "3"],
      collapseActiveNames: ["1", "2", "3"],
      sizeTypes: [
        {
          label: "px",
          value: "px"
        },
        {
          label: "%",
          value: "%"
        }
      ],
      maxWidth: null,
      maxHeight: null,
      disAbledWidth: false,
      disAbledHeight: false,
      idChange: false,
      before: null
    }
  },
  comments: {},
  components: {},
  directives: {
    swiper: directive
  },
  created() {},
  watch: {},
  computed: {
    pluginName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.options, "pluginName", "pluginName", [])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pluginName", false)
      }
    },
    ids() {
      console.log("this.options", this.options)
      return this.$store.state.states.activeID
    },
    direction: {
      get() {
        return this.options.options.drawerParams.direction
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "direction", false)
      }
    },
    width: {
      get() {
        return this.options.options.drawerParams.width || 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "drawerParams.width", false)
        let list = this.$store.state[this.request_prefix].page.pageLayoutList
        // 根据this.options.id找到对应的pageLayoutList
        let pageLayoutList = list.find(it => it.id === this.options.id)
        pageLayoutList.layout.rows[0].options.width = newVal - 6
        this.$store.dispatch(this.request_prefix + "/changePageLayout", { pageLayoutList: list })
      }
    },
    height: {
      get() {
        return this.options.options.drawerParams.height || 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "drawerParams.height", false)
        let list = this.$store.state[this.request_prefix].page.pageLayoutList
        // 根据this.options.id找到对应的pageLayoutList
        let pageLayoutList = list.find(it => it.id === this.options.id)
        pageLayoutList.layout.rows[0].options.height = newVal - 6
        this.$store.dispatch(this.request_prefix + "/changePageLayout", { pageLayoutList: list })
      }
    },
    opacity: {
      get() {
        return this.options.options.drawerParams.opacity
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "drawerParams.opacity", false)
      }
    },
    borderStyle: {
      get() {
        return this.options.options.drawerParams.borderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "drawerParams.borderStyle", false)
      }
    },
    borderColor: {
      get() {
        return this.options.options.drawerParams.borderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "drawerParams.borderColor", false)
      }
    },
    borderWidth: {
      get() {
        return this.options.options.drawerParams.borderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "drawerParams.borderWidth", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.options.options.drawerParams.borderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "drawerParams.borderIsThemeColor", false)
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.options.options.drawerParams.borderRadius[0]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "drawerParams.borderRadius.0", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return this.options.options.drawerParams.borderRadius[1]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "drawerParams.borderRadius.1", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.options.options.drawerParams.borderRadius[2]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "drawerParams.borderRadius.2", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.options.options.drawerParams.borderRadius[3]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "drawerParams.borderRadius.3", false)
      }
    },
    borderRadius: {
      get() {
        return this.options.options.drawerParams.borderRadius[0]
      },
      set(newVal) {
        this.$changeOptionsEV([newVal, newVal, newVal, newVal], "drawerParams.borderRadius", false)
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.options.drawerParams.hasOwnProperty("borderTypeFlag")) {
          if (((this.borderRadius[0] === this.borderRadius[1]) === this.borderRadius[2]) === this.borderRadius[3]) {
            defaultType = 2
          }
        }
        return this.options.options.drawerParams.borderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "drawerParams.borderTypeFlag", false)
      }
    },
    background: {
      get() {
        let background = this.options.options.bg
        if (background && Array.isArray(background) && background.length > 0) {
          return background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.options.bgColor || "rgba(255,255,255,0)"
          }
        ]
        this.$changeOptionsEV(newBackground, "bg", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "bg", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.options, "boxShadowColor", "boxShadowColor", [
          "rgba(255,255,255,1)"
        ])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.options, "boxShadowH", "boxShadowH", [0])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.options, "boxShadowV", "boxShadowV", [0])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.options, "boxShadowBlur", "boxShadowBlur", [0])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.options, "boxShadowSpread", "boxShadowSpread", [0])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    modalColorArr: {
      get() {
        let color = this.options.options.drawerParams.modalColorArr
        if (color && JSON.stringify(color) !== "{}") {
          return color
        }
        let newColor = {
          type: "color",
          label: "颜色",
          isThemeColor: false,
          data: {
            angle: 0,
            stops: [
              [this.options.options.drawerParams.color, 0],
              [this.options.options.drawerParams.color, 1]
            ]
          }
        }
        this.$changeOptionsEV(newColor, "drawerParams.modalColorArr", false)
        return newColor
      },
      set(val) {
        this.$changeOptionsEV(val, "drawerParams.modalColorArr", false)
      }
    },
    modalActiveNameColor: {
      get() {
        return this.options.options.drawerParams.modalActiveNameColor || "first"
      },
      set(val) {
        this.$changeOptionsEV(val, "drawerParams.modalActiveNameColor", false)
      }
    },
    modalTextIsThemeColor: {
      get() {
        return this.options.options.drawerParams.modalTextIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "drawerParams.modalTextIsThemeColor", false)
      }
    }
  },
  methods: {
    getParentNode() {
      let nodeClass = "container_id_" + this.ids.container_id + "-rect_id_" + this.ids.rect_id
      if (this.ids.uid !== null && typeof this.ids.uid !== "undefined") {
        nodeClass =
          "container_id_" +
          this.ids.container_id +
          "-rect_id_" +
          this.ids.rect_id +
          "-uid_" +
          this.ids.uid +
          "-elementInLayoutId_" +
          this.ids.elementInLayoutId
      }
      if (this.ids.directionIndex !== null && typeof this.ids.directionIndex !== "undefined") {
        nodeClass =
          "container_id_" +
          this.ids.container_id +
          "-rect_id_" +
          this.ids.rect_id +
          "-directionIndex_" +
          this.ids.directionIndex +
          "-elementInLayoutId_" +
          this.ids.elementInLayoutId
      }
      if (this.ids.elementInSwiperId !== null && typeof this.ids.elementInSwiperId !== "undefined") {
        nodeClass =
          "container_id_" +
          this.ids.container_id +
          "-rect_id_" +
          this.ids.rect_id +
          "-swiperContent_id_" +
          this.ids.swiperContent_id +
          "-elementInSwiperId_" +
          this.ids.elementInSwiperId
      }
      console.log("nodeClass :>>", nodeClass)
      let parentNode = document.getElementsByClassName(nodeClass)[0]?.parentNode
      this.parentW = parentNode?.offsetWidth
      this.parentH = parentNode?.offsetHeight
      this.setInputMaxMin()
    },
    // 计算输入框的最大最小值
    setInputMaxMin() {
      // 快捷定位之后，最大宽度/高度选择父容器的高度
      if (this.options.isQuickSite) {
        this.maxWidth = this.parentW
        this.maxHeight = this.parentH
        this.maxLeft = 100
        this.maxTop = 100
      } else {
        let currentWidth = this.widthType === "%" ? parseInt((this.width * this.parentW) / 100) : this.width
        let currentHeight = this.heightType === "%" ? parseInt((this.height * this.parentH) / 100) : this.height
        let currentLeft = this.leftType === "%" ? parseInt((this.left * this.parentH) / 100) : this.left
        let currentTop = this.leftType === "%" ? parseInt((this.top * this.parentH) / 100) : this.top
        let offsetLeft = 0
        let offsetTop = 0
        if (this.leftType === "%") {
          offsetLeft = this.options.offset ? this.options.offset[1] + this.options.offset[3] : 0
        }
        if (this.topType === "%") {
          offsetTop = this.options.offset ? this.options.offset[0] + this.options.offset[2] : 0
        }
        // console.log('this.parentW :>>', this.parentW, this.parentH, currentWidth, currentHeight, currentLeft, currentTop);
        this.maxWidth = this.widthType === "%" ? 100 : Math.floor(this.parentW - currentLeft - offsetLeft)
        this.maxWidth === 0 ? (this.maxWidth = currentWidth) : ""
        this.maxHeight = this.heightType === "%" ? 100 : Math.floor(this.parentH - currentTop - offsetTop)
        this.maxHeight === 0 ? (this.maxHeight = currentHeight) : ""
        this.maxLeft = this.leftType === "%" ? 100 : Math.floor(this.parentW - currentWidth)
        this.maxTop = this.topType === "%" ? 100 : Math.floor(this.parentH - currentHeight)
        // console.log('this.maxWidth :>>', this.maxWidth, this.maxHeight, this.maxLeft, this.maxTop);
      }
    },
    fixGetNumber(name) {
      const num =
        this.mouseType === "hover" ? this.options["hover" + name[1].toUpperCase() + name.slice(1)] : this.options[name]
      if (String(num).includes(".")) {
        return String(num).split(".")[1].length > 2 ? num.toFixed(2) : num
      } else return num
    },
    fixSetNumber(num) {
      if (String(num).includes(".")) {
        return String(num).split(".")[1].length > 2 ? num.toFixed(2) : num
      }
      return num
    },
    leftTypeHandleCommand(val) {
      if (this.leftType === val) {
        return
      }
      this.leftType = val
      this.left = 0
      this.margin = null
      this.offset = null
    },
    topTypeHandleCommand(val) {
      if (this.topType === val) {
        return
      }
      this.topType = val
      this.top = 0
      this.margin = null
      this.offset = null
    },
    widthTypeHandleCommand(val) {
      if (this.widthType === val) {
        return
      }
      this.widthType = val
      this.width = val === "%" ? 100 : 200
    },
    heightTypeHandleCommand(val) {
      if (this.heightType === val) {
        return
      }
      this.heightType = val
      this.height = val === "%" ? 100 : 200
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    changeValue() {
      if (this.margin) {
        this.margin = null
      }
    },
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    }
  }
})
</script>

<style scoped lang="scss">
p {
  margin-bottom: 0;
}

.arrange-sets {
  justify-content: space-between;
}

.row-set {
  flex: 1;

  input {
    background-color: var(--inputBg);
    border-radius: 4px;
    padding: 0 10px;
    box-sizing: border-box;
    margin-right: 16px;
  }

  .btn-wrapper {
    flex: 1;
    background-color: var(--inputBg);
    border-radius: 4px;
    padding: 6px 0;
    font-size: 0;

    .num-btn {
      display: inline-block;
      width: 50%;
      text-align: center;
      line-height: 20px;
      font-size: 13px;
      cursor: pointer;
      color: var(--subTextColor);

      &:not(:last-child) {
        border-right: 1px solid var(--sliderBackGround);
      }

      &:not(.disabled):hover {
        color: var(--themeColor);
      }

      &.disabled {
        color: var(--borderColorSeven);
        cursor: not-allowed;
      }
    }
  }
}

.lineHeight32 {
  display: inline-block;
  line-height: 32px;
}

::v-deep.content-group-default .el-input input {
  background: var(--inputBackGround);
  color: var(--textColor);
}

::v-deep input {
  color: var(--textColor);
}

.mt4 {
  margin-top: 4px;
}

.content {
  position: relative;
}

.types-options-style {
  padding: 12px 16px 0 16px;

  &:hover {
    .swiper-button {
      display: block;
    }
  }
}

.pd12-16 {
  padding: 12px 16px;
}

.types-list {
  .types-list-li {
    position: relative;
    display: inline-block;
    margin-right: 8px;
    margin-bottom: 16px;
    width: calc(((100% - 16px) / 3));
    cursor: pointer;

    &:nth-child(3n) {
      margin-right: 0;
    }

    .img-box {
      position: relative;
      width: 100%;
      height: 50px;
      border-radius: 4px;
      border: 1px solid var(--elCollapseItemBorderColor);
      background: var(--editBgColor);
      box-sizing: border-box;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    p {
      margin-bottom: 0;
      color: var(--textColor);
      line-height: 20px;
      margin-top: 8px;
      text-align: center;
    }

    .delete-icon {
      position: absolute;
      display: none;
      bottom: 2px;
      right: 2px;
      border-radius: 2px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      background-color: var(--iconHoverBgColor);
      color: var(--iconColor);
    }

    .icon-checked {
      position: absolute;
      right: 0;
      top: 0;
      width: 24px;
      height: 24px;
      background-image: url(../../../assets/images/icon-checked.png);
      background-size: 100% 100%;
      display: none;
    }

    &:hover {
      .delete-icon {
        display: block;
      }
    }

    &.active {
      .img-box {
        border: 2px solid var(--themeColor);

        .icon-checked {
          display: block;
        }
      }
    }
  }
}

.swiper-button {
  width: 14px;
  height: 46px;
  line-height: 45px;
  text-align: center;
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  border-radius: 0px 2px 2px 0px;
  color: var(--subTextColor);
  margin-top: -48px;
  display: none;
}

.swiper-button::after {
  font-size: 12px;
}

.swiper-button-prev {
  left: -14px;
}

.swiper-button-next {
  right: -14px;
}

.margin-top-16 {
  margin-top: 16px;
}

.move-speed-btn {
  display: inline-flex;
  position: relative;
  width: 156px;
  background: var(--inputBackGround);
  height: 30px;
  padding: 3px;
  border-radius: 4px;
  box-sizing: border-box;
  user-select: none;

  span {
    width: 50px;
    text-align: center;
    line-height: 24px;
    cursor: pointer;
    color: var(--thirdTextColor);
    position: relative;

    &::after {
      position: absolute;
      content: "";
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: 14px;
      background: var(--borderColorSeven);
    }

    &.btn-active::after,
    &.select::after,
    &.select + span::after,
    &:nth-child(2)::after {
      display: none;
    }
  }

  .btn-active {
    height: 24px;
    position: absolute;
    top: 3px;
    background: var(--leftMenuBgColor);
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  .pd2 {
    z-index: 1;
  }

  .select {
    color: var(--themeColor) !important;
  }
}

.custom-label {
  display: inline-block;
  vertical-align: middle;
}

.custom-width-inp {
  vertical-align: middle;
  overflow: hidden;
}
.more-btn {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--thirdTextColor);
  font-weight: 400;
}
.more-btn:hover {
  color: var(--themeColor);
}
</style>
